<template>
  <div>
    <Head title="Descuentos Globales de Productos" />
    <h1 class="mb-8 text-3xl font-bold">Descuentos Globales</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Codigo:</label>
        <select v-model="form.code" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="code in codes" :key="code.id" :value="code.description">{{ code.description }}</option>
        </select>
      </search-filter>
      <Link class="btn-sky" href="/settings/products/global-discounts/create">
        <span>Crear</span>
        <span class="hidden md:inline">&nbsp;Descuento Global</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">Cantidad</th>
          <th class="pb-4 pt-6 px-2">Porcentaje</th>
          <th class="pb-4 pt-6 px-2">Estatus</th>
          <th class="pb-4 pt-6 px-2">Fecha de creación</th>
        </tr>
        <tr v-for="global in globalDiscounts" :key="global.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4">{{ global.quantity }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4">{{ global.porcent }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4">{{ global.status }}</Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4">{{ global.created_at }}</Link>
          </td>
        </tr>
        <tr>
          <td class="px-6 py-4 border-t" colspan="4">No se encontraron descuentos globales</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
  
export default {
  components: {
    Head,
    Link,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    globalDiscounts: Array,
    codes: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        code: this.filters.code,
      },
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>